import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const subitem = (filtro = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.get('produtos/itens/subitens/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.PRODUTOS.PESQUISA_SUBITEM);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    
    return async dispatch => {

        dispatchpending(dispatch);

        try{
            const response = await axios.put('produtos/itens/subitens/novoatualiza',
                {
                    ...dados
                },
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.PRODUTOS.PRODNOVOATUALIZA);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}

export const zeranovoatualiza = (evento = {}) => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.PRODNOVOATUALIZA,
        payload: evento
      })
    }
}

export const subitemselecionado = (evento = {}) => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.SUBITEMSELECIONADO,
        payload: evento
      })
    }
}

export const subitemzeraselecionado = () => {
    return dispatch => {
      dispatch({
        type: types.PRODUTOS.SUBITEMSELECIONADO,
        payload: {}
      })
    }
}

export const zerapesquisa = () => {
    return dispatch => {       
        dispatch({
            payload: {},
            type: types.PRODUTOS.PESQUISA_SUBITEM
        })
    }
}